import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { RequisitoSenha } from '../hooks/useRequisitosSenha';

interface PainelRequisitosSenhaProps {
  requisitosSenha: RequisitoSenha[];
  forcaSenha: number;
  classeCorBarraForca: string;
  classeCorTextoForca: string;
  exibirForcaSenha: boolean;
}

const PainelRequisitosSenha: React.FC<PainelRequisitosSenhaProps> = ({
  requisitosSenha,
  forcaSenha,
  classeCorBarraForca,
  classeCorTextoForca,
  exibirForcaSenha
}) => {
  // Comentario (function-level): Renderiza o painel compartilhado de requisitos e forca da senha
  // para evitar divergencia visual entre os fluxos de alteracao e redefinicao.
  const { t } = useLanguage();
  const { theme } = useTheme();

  return (
    <>
      {exibirForcaSenha && (
        <div className="mt-3">
          <div className="mb-2 flex items-center justify-between">
            <small className={theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}>
              {t('auth.passwordStrength')}:
            </small>
            <small className={classeCorTextoForca}>
              {forcaSenha}%
            </small>
          </div>
          <div className={`h-1.5 overflow-hidden rounded-full ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-200'}`}>
            <div
              className={`h-full rounded-full ${classeCorBarraForca}`}
              style={{ width: `${forcaSenha}%` }}
              aria-valuenow={forcaSenha}
              aria-valuemin={0}
              aria-valuemax={100}
            />
          </div>
        </div>
      )}

      <div className={`mt-4 rounded-xl border border-dashed p-4 ${theme === 'dark' ? 'border-gray-600 bg-gray-900/40' : 'border-gray-300 bg-gray-50'}`}>
        <small className={`mb-3 block text-xs font-medium uppercase tracking-wide ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
          {t('auth.passwordRequirements')}
        </small>
        {requisitosSenha.map((requisitoSenha) => (
          <div key={requisitoSenha.id} className="mb-2 flex items-center last:mb-0">
            <span
              className={`mr-2 text-xs ${requisitoSenha.valido ? 'text-green-500' : 'text-red-500'}`}
              aria-hidden="true"
            >
              {requisitoSenha.valido ? '✓' : '✗'}
            </span>
            <small className={requisitoSenha.valido ? 'text-green-500' : theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}>
              {requisitoSenha.texto}
            </small>
          </div>
        ))}
      </div>
    </>
  );
};

export default PainelRequisitosSenha;
